// RadialProgress.jsx
export default function RadialProgress({ value, max, size, thickness, color }) {
  const radius = size / 2;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference - (value / max) * circumference;

  return (
    <div className="relative" style={{ width: size, height: size }}>
      <svg className="absolute inset-0" viewBox={`0 0 ${size} ${size}`}>
        <circle
          cx={radius}
          cy={radius}
          r={radius - thickness / 2}
          fill="none"
          stroke="#e5e7eb"
          strokeWidth={thickness}
        />
        <circle
          cx={radius}
          cy={radius}
          r={radius - thickness / 2}
          fill="none"
          strokeLinecap="round"
          className={`stroke-current ${color}`}
          strokeWidth={thickness}
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          transform={`rotate(-90 ${radius} ${radius})`}
        />
      </svg>
    </div>
  );
}
